export default "__VITE_ASSET__DeXErvA9__"